var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcBuilding = function SvgIcBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D85FF",
    fillOpacity: 0.6,
    fillRule: "evenodd",
    d: "M10.998 3.5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3v-12a3 3 0 0 0-3-3zm5.427 3a1 1 0 0 0-1 1v.6a1 1 0 0 0 1 1h.415a1 1 0 0 0 1-1v-.6a1 1 0 0 0-1-1zm-4.712 1a1 1 0 0 1 1-1h.414a1 1 0 0 1 1 1v.6a1 1 0 0 1-1 1h-.414a1 1 0 0 1-1-1zm4.712 3a1 1 0 0 0-1 1v.6a1 1 0 0 0 1 1h.415a1 1 0 0 0 1-1v-.6a1 1 0 0 0-1-1z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D85FF",
    d: "M2.002 14.83a2 2 0 0 1 .757-1.567l3.5-2.777a2 2 0 0 1 2.486 0l3.5 2.777a2 2 0 0 1 .757 1.567v4.67a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.498,
    cy: 16.499,
    r: 2,
    fill: "#fff"
  })));
};
export default SvgIcBuilding;